// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { LinkedSystem, LinkedSystemAccLinkingValue } from "../misc/LinkedSystem.js";
import { TerceraInstrumentLookupDropDownForm } from "../elements/Lookup/TerceraInstrumentLookupDropDownForm.js";
import { QuickTableRactive } from "../elements/QuickTable/QuickTableRactive.js";
import { TerceraButton } from "../elements/TerceraButton.js";
import { TerceraLabel } from "../elements/TerceraLabel.js";
import { TerceraLinkLabel } from "../elements/TerceraLinkLabel.js";
import { PanelNames } from "../UtilsClasses/FactoryConstants.js";
import { LookupDropDownShowParams } from "../UtilsClasses/LookupDropDownShowParams.js";
import { ApplicationPanelNew } from "./ApplicationPanelNew.js";
import { TerceraPortfolioTable } from "./TerceraPortfolioTable.js";
import { DynProperty } from "../../Commons/DynProperty.js";
import { DataCache } from "../../Commons/DataCache.js";
import { TerceraSymbolLookupBaseDataProvider } from "../../Commons/NoNFixedListCore.js";
import { TerceraLookup } from "../elements/Lookup/TerceraLookup.js";
import { TerceraAccountLookup } from "../elements/Lookup/TerceraAccountLookup.js";


export let MarginInfoPanel = ApplicationPanelNew.extend({
    data: function ()
    {
        return {
            isAccountLinkShow: true
        };
    },
    Name: 'MarginInfoPanel',
    topPanelHeight: 25,
    headerLocaleKey: 'panel.MarginInfo',
    NeedCalculateRowCount: false,
    accLookup: null,
    account: null,
    btnAdd: null,
    formattedCountdown: null,
    formattedInitialMargin: null,
    formattedMaintenanceMargin: null,
    pendingInstrumentData: null
});

MarginInfoPanel.prototype.getType = function () { return PanelNames.MarginInfoPanel; };


MarginInfoPanel.prototype.oninit = function ()
{
    ApplicationPanelNew.prototype.oninit.apply(this);
    this.topPanelHeight = this.showTopPanel() ? 25 : 0;
};

// TODO. Duplicated from AccountDetailsPanel.
MarginInfoPanel.prototype.showTopPanel = function ()
{
    var dc = DataCache;
    var accounts = dc.Accounts;
    var accKeys = Object.keys(accounts);

    return accKeys.length > 1 || accounts[accKeys[0]].assetIds.length > 1;
};

MarginInfoPanel.prototype.oncomplete = function ()
{
    ApplicationPanelNew.prototype.oncomplete.apply(this);

    this.dataProvider = new TerceraSymbolLookupBaseDataProvider();

    var topQT = this.quickTableRactive.quickTable;

    topQT.allowGroupBy = false;
    topQT.lockManualSorting = true;
    topQT.OnGroupsVisibilityChanged.Subscribe(this.layoutTable, this);

    var openInstrumentDropDown = this.openInstrumentDropDown.bind(this);

    var accLookup = new TerceraAccountLookup();
    this.accLookup = accLookup;

    accLookup.set({
        top: 5,
        left: 5,
        visible: DataCache.AccountsCount > 1
    });
    accLookup.observe('selectedItem', this.onAccLookupSelectedItemChanged.bind(this));
    this.addControl(accLookup);

    if (this.deferredLinkInAccId)
    {
        var self = this;
        accLookup.on('complete', function ()
        {
            self.accountLink_In(self.deferredLinkInAccId);
            delete self.deferredLinkInAccId;
        });
    }

    var refreshLink = new TerceraLinkLabel();
    refreshLink.set('name', 'refreshLink');
    refreshLink.on(TerceraLinkLabel.Events.Click, this.refresh.bind(this));
    this.addControl(refreshLink);

    var btnAdd = new TerceraButton();
    btnAdd.set({
        name: 'btnAdd',
        terceraButtonStyle: 'js-addBtn-Instruments',
    });
    btnAdd.on(TerceraButton.Events.onClick, openInstrumentDropDown);
    this.addControl(btnAdd);

    var portfolioTable = new TerceraPortfolioTable();
    portfolioTable.set('name', 'portfolioTable');
    this.addControl(portfolioTable);

    portfolioTable.on(
        QuickTableRactive.Events.DoubleClick,
        openInstrumentDropDown);

    portfolioTable.on(
        TerceraPortfolioTable.Events.RemoveRow,
        this.removePortfolioRow.bind(this));

    portfolioTable.on(
        TerceraPortfolioTable.Events.AnalyzeRow,
        this.changeAnalyzeRow.bind(this));

    portfolioTable.on(
        TerceraPortfolioTable.Events.QuantityRow,
        this.changeQuantityRow.bind(this));

    portfolioTable.on(
        TerceraPortfolioTable.Events.LoadRows,
        this.loadRows.bind(this));

    if (this.deferredPortfolioTableXml)
    {
        portfolioTable.setXmlSettingsTemplate(this.deferredPortfolioTableXml);
        delete this.deferredPortfolioTableXml;
    }

    if (this.deferredPortfolioProperties)
    {
        portfolioTable.callBack(this.deferredPortfolioProperties);
        delete this.deferredPortfolioProperties;
    }

    var labelInitMargin = new TerceraLabel();
    labelInitMargin.set('name', 'labelInitMargin');
    this.addControl(labelInitMargin);

    var labelMaintenanceMargin = new TerceraLabel();
    labelMaintenanceMargin.set('name', 'labelMaintenanceMargin');
    this.addControl(labelMaintenanceMargin);

    this.layoutTable();
    this.localize();
};

MarginInfoPanel.prototype.canAddRowsCallBack = function ()
{
    var data = this.pendingInstrumentData;
    if (!data) return;

    this.pendingInstrumentData = null;
};

MarginInfoPanel.prototype.changeAnalyzeRow = function (id)
{
    //TODO
    return;
};

MarginInfoPanel.prototype.removePortfolioRow = function (id)
{
    //TODO
    return;
};

MarginInfoPanel.prototype.changeQuantityRow = function (id, amount)
{
    if (amount === 0)
    {
        this.removePortfolioRow(id);
        return;
    }

    //TODO
    return;
 
};

MarginInfoPanel.prototype.loadRows = function (insArr)
{
    return;
};

MarginInfoPanel.prototype.openInstrumentDropDown = function ()
{
    var obj = {};
    (TerceraLookup.prototype.setItems.bind(obj))(DataCache.Instruments);

    var params = new LookupDropDownShowParams();
    params.items = obj.items;
    params.callBack = this.instrumentsDropDownCallback.bind(this);
    params.isMultiSelect = false;
    params.showButtons = true;
    params.isCentered = true;
    params.autoClose = false;
    params.parentPanel = this;
    params.dataProvider = this.dataProvider;
    TerceraInstrumentLookupDropDownForm.ShowForm(params);
};

MarginInfoPanel.prototype.instrumentsDropDownCallback = function (instrument)
{
    //TODO
        return;
};

MarginInfoPanel.prototype.refresh = function ()
{
    //TODO
    return;
}

MarginInfoPanel.prototype.onAccLookupSelectedItemChanged = function (account, oldAccount)
{
    if (!account || account === oldAccount)
        return;

    this.account = account;
    this.accountLink_Out(false, account);
};

MarginInfoPanel.prototype.accountLink_Out = function (newSubscriber, account)
{
    account = account || this.account;
    if (!account) return;

    if (LinkedSystem.accLinkingActive)
        LinkedSystem.setAccount(LinkedSystemAccLinkingValue, account, newSubscriber);
};

MarginInfoPanel.prototype.accountLink_In = function (accId)
{
    if (this.accLookup && DataCache.Accounts[accId])
        this.accLookup.setSelectValue(DataCache.Accounts[accId]);
    else if (DataCache.Accounts[accId])
        this.deferredLinkInAccId = accId;
};

MarginInfoPanel.prototype.layoutTable = function ()
{
    var qtMi = this.quickTableRactive;
    if (!qtMi || !qtMi.quickTable) return;

    var portfolioTable = this.Controls.portfolioTable;
    if (!portfolioTable) return;

    var btnAdd = this.Controls.btnAdd;
    if (!btnAdd) return;

    var refreshLink = this.Controls.refreshLink;
    if (!refreshLink) return;

    var labelInitMargin = this.Controls.labelInitMargin;
    if (!labelInitMargin) return;

    var labelMaintenanceMargin = this.Controls.labelMaintenanceMargin;
    if (!labelMaintenanceMargin) return;

    var margin = this.margin;
    var doubleMargin = margin * 2;

    var availableW = this.get('width') - doubleMargin;
    if (availableW < 0) availableW = 0;

    var left = margin;

    var availableH = this.get('height') - doubleMargin - this.topPanelHeight;
    if (availableH < 0) availableH = 0;

    var miTop = this.topPanelHeight + margin;
    var miH = qtMi.quickTable.getVisibleDataHeight();
    if (miH > availableH) miH = availableH;

    qtMi.setBounds(left, miTop, availableW, miH);

    var btnTop = miH + miTop + margin;
    btnAdd.setBounds(left + 2, btnTop, 25, 25);
    refreshLink.set({ right: margin, top: btnTop - 1 });

    var portfolioTableTop = btnTop + 20 + margin;

    var portfolioTableH = availableH - portfolioTableTop + doubleMargin;
    if (portfolioTableH < 0) portfolioTableH = 0;

    portfolioTable.setBounds(left, portfolioTableTop, availableW, portfolioTableH);

    var labelTop = portfolioTableTop + portfolioTableH + margin;

    labelInitMargin.setLocation(left, labelTop);
    labelMaintenanceMargin.setLocation(left + 180, labelTop);
};

MarginInfoPanel.prototype.themeChange = function ()
{
    ApplicationPanelNew.prototype.themeChange.apply(this);

    var btnAdd = this.Controls.btnAdd;
    if (btnAdd)
        btnAdd.set('terceraButtonStyle', "js-addBtn-Instruments");

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable) portfolioTable.themeChange();
};

MarginInfoPanel.prototype.localize = function ()
{
    ApplicationPanelNew.prototype.localize.apply(this);

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable) portfolioTable.localize();

    this.updateLabels();
};

MarginInfoPanel.prototype.TickAsync = function ()
{
    ApplicationPanelNew.prototype.TickAsync.apply(this);
    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable) portfolioTable.TickAsync();
};

MarginInfoPanel.prototype.Update = function (updatePackage)
{
    ApplicationPanelNew.prototype.Update.call(this, updatePackage);

    //#region Table Groups Stuff. TODO. Remove after implementing groups.
    var qtRactive = this.quickTableRactive;
    var groupRowsAdded = qtRactive && AccountDetailsPanel.Update(qtRactive.quickTable, updatePackage);
	//#endregion

	// http://tp.pfsoft.net/entity/59156
	// TODO. Ugly. Raise event for a newly added group row.
    if (groupRowsAdded) this.layoutTable();

    var additionalTableData = updatePackage.additionalTableData;
    if (!additionalTableData) return;

    if (additionalTableData.hasOwnProperty(MarginInfoPanel.INITIAL_MARGIN_KEY))
        this.formattedInitialMargin = additionalTableData[MarginInfoPanel.INITIAL_MARGIN_KEY];

    if (additionalTableData.hasOwnProperty(MarginInfoPanel.MAINTENANCE_MARGIN_KEY))
        this.formattedMaintenanceMargin = additionalTableData[MarginInfoPanel.MAINTENANCE_MARGIN_KEY];

    if (additionalTableData.hasOwnProperty(MarginInfoPanel.COUNTDOWN_KEY))
        this.formattedCountdown = additionalTableData[MarginInfoPanel.COUNTDOWN_KEY];

    this.updateLabels();
};

MarginInfoPanel.prototype.updateLabels = function ()
{
    var controls = this.Controls;

    if (controls.labelInitMargin)
        controls.labelInitMargin.set(
            'text',
            Resources.getResource('panel.MarginInfo.InitMargin') + ' ' +
            (this.formattedInitialMargin || ''));

    if (controls.labelMaintenanceMargin)
        controls.labelMaintenanceMargin.set(
            'text',
            Resources.getResource('panel.MarginInfo.MaintMargin') + ' ' +
            (this.formattedMaintenanceMargin || ''));

    var refreshString = Resources.getResource('panel.newOrderEntry.RefreshMarginReq');
    if (this.formattedCountdown)
    {
        refreshString +=
            '(' +
            this.formattedCountdown +
            Resources.getResource('panel.MarginInfo.timetoUpdate.s') +
            ')';
    }
    if (controls.refreshLink)
        controls.refreshLink.set('text', refreshString);
};

//#region ICaller

MarginInfoPanel.prototype.callBack = function (newProperties)
{
    ApplicationPanelNew.prototype.callBack.call(this, newProperties);

    var id = DynProperty.getPropValue(newProperties, "AccountId");
    if (id) this.accountLink_In(id);

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable)
        portfolioTable.callBack(newProperties);
    else
        this.deferredPortfolioProperties = newProperties;
};

MarginInfoPanel.prototype.Properties = function ()
{
    var properties = ApplicationPanelNew.prototype.Properties.call(this);

    properties.push(new DynProperty(
        "AccountId",
        this.accLookup.get('selectedItem').AcctNumber,
        DynProperty.STRING,
        DynProperty.HIDDEN_GROUP));

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable)
    {
        var portfolioProps = portfolioTable.Properties();
        if (portfolioProps)
            properties = properties.concat(portfolioProps);
    };

    return properties;
};

//#endregion

//#region XmlSettings

MarginInfoPanel.prototype.getXmlSettingsTemplate = function ()
{
    var xml = ApplicationPanelNew.prototype.getXmlSettingsTemplate.apply(this);

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable)
        xml.portfolioTable = portfolioTable.getXmlSettingsTemplate();

    return xml;
};

MarginInfoPanel.prototype.setXmlSettingsTemplate = function (xml)
{
    ApplicationPanelNew.prototype.setXmlSettingsTemplate.call(this, xml);

    if (!xml || !xml.portfolioTable)
        return;

    var portfolioTable = this.Controls.portfolioTable;
    if (portfolioTable)
        portfolioTable.setXmlSettingsTemplate(xml.portfolioTable);
    else
        this.deferredPortfolioTableXml = xml.portfolioTable;
};

//#endregion

//----------------

MarginInfoPanel.INITIAL_MARGIN_KEY = 'initMargin';
MarginInfoPanel.MAINTENANCE_MARGIN_KEY = 'maintMargin';
MarginInfoPanel.COUNTDOWN_KEY = 'countdown';

//----------------

MarginInfoPanel.prototype.repopulate = function ()
{
    ApplicationPanelNew.prototype.repopulate.apply(this);

    var props = this.Controls.portfolioTable.Properties();
    this.Controls.portfolioTable.quickTableRactive.quickTable.ClearAll();
    this.Controls.portfolioTable.callBack(props);

    if (this.accLookup)
        this.onAccLookupSelectedItemChanged(this.accLookup.get('selectedItem'));
};